// Content sourced from eewaste.com — preserved verbatim for SEO continuity.

export const CONTACT = {
  phone: "(305) 691-1516",
  phoneHref: "tel:+13056911516",
  phonePlain: "305-691-1516",
  email: "info@eewaste.com",
  company: "Empire Environmental Waste Inc",
  brandShort: "EWS",
  area: "Miami & Miami-Dade County, Florida",
  address: "10715 S.W. 190th Street, Miami, FL 33177",
};

// Sitewide LocalBusiness structured data (JSON-LD) — helps Google's local pack & rich results.
// NAP kept accurate: no invented street address; hours match the header (Mon–Sat 7am–6pm).
export const BUSINESS_SCHEMA = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "@id": "https://eewaste.com/#business",
  name: "EWS",
  legalName: "Empire Environmental Waste Inc",
  url: "https://eewaste.com",
  logo: "https://eewaste.com/img/ews-logo.jpg",
  image: "https://eewaste.com/img/ews-logo.jpg",
  telephone: "+13056911516",
  email: "info@eewaste.com",
  priceRange: "$$",
  description:
    "Locally owned commercial waste management and dumpster rental company serving Miami and Miami-Dade County for 30+ years. Front-load commercial service and 10–40 yard roll-off dumpster rentals.",
  address: {
    "@type": "PostalAddress",
    streetAddress: "10715 SW 190th Street",
    addressLocality: "Miami",
    addressRegion: "FL",
    postalCode: "33177",
    addressCountry: "US",
  },
  areaServed: {
    "@type": "AdministrativeArea",
    name: "Miami-Dade County, Florida",
  },
  contactPoint: [{
    "@type": "ContactPoint",
    telephone: "+13056911516",
    email: "info@eewaste.com",
    contactType: "sales and customer support",
    areaServed: "Miami-Dade County, Florida",
    availableLanguage: ["English", "Spanish"],
  }],
  hasOfferCatalog: {
    "@type": "OfferCatalog",
    name: "EWS waste management services",
    itemListElement: [
      {
        "@type": "Offer",
        name: "Commercial front-load waste collection",
        itemOffered: { "@type": "Service", name: "2–8 yard commercial front-load waste collection" },
        priceSpecification: { "@type": "PriceSpecification", price: "55", priceCurrency: "USD", description: "Starting monthly price" },
      },
      {
        "@type": "Offer",
        name: "Roll-off dumpster rental",
        itemOffered: { "@type": "Service", name: "10–40 yard roll-off dumpster rental" },
        priceSpecification: { "@type": "PriceSpecification", price: "289", priceCurrency: "USD", description: "Starting price for a 14-day rental" },
      },
      {
        "@type": "Offer",
        name: "Commercial recycling service",
        itemOffered: { "@type": "Service", name: "Commercial recycling and waste diversion programs" },
      },
      {
        "@type": "Offer",
        name: "WiseWaste invoice review",
        itemOffered: { "@type": "Service", name: "Waste invoice review and price comparison" },
        priceSpecification: { "@type": "PriceSpecification", price: "0", priceCurrency: "USD", description: "Free invoice review" },
      },
    ],
  },
  openingHoursSpecification: [
    {
      "@type": "OpeningHoursSpecification",
      dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
      opens: "07:00",
      closes: "18:00",
    },
  ],
  knowsAbout: [
    "Commercial waste management",
    "Dumpster rental",
    "Roll-off dumpster rental",
    "Recycling services",
  ],
};

// Primary navigation (router paths)
export const NAV = [
  { label: "Home", to: "/" },
  { label: "Business Waste", to: "/business-waste-service" },
  { label: "Dumpster Rentals", to: "/dumpster-rentals" },
  { label: "Recycling", to: "/recycling" },
  { label: "WiseWaste Calculator", to: "/savings-calculator" },
  { label: "Who We Are", to: "/who-we-are" },
  { label: "Contact", to: "/contact" },
];

// Legacy anchor links used by Home page sections
export const NAV_LINKS = [
  { label: "Services", href: "#services" },
  { label: "Recycling", href: "#recycling" },
  { label: "Why EWS", href: "#why" },
  { label: "Coverage", href: "#coverage" },
  { label: "Reviews", href: "#reviews" },
];

export const HERO_LINES = [
  "Affordable, Simple",
  "Waste Management &",
  "Dumpster Rental",
  "Solutions.",
];

export const STATS = [
  { metric: "30+", label: "Years Experience" },
  { metric: "30%", label: "Average Savings Per Customer" },
  { metric: "38", label: "Miami-Dade Areas Served" },
  { metric: "100%", label: "Compliant Recycling & Disposal" },
];

export const TRUST_BADGES = [
  "5-Star Rated on Google",
  "Top Rated Service",
  "A+ BBB Rating",
];

export const MARQUEE_ITEMS = [
  "Business Waste Pickup",
  "Roll-Off Dumpster Rental",
  "Recycling & Disposal",
  "Miami, Florida",
  "30 Years Experience",
  "Save Up To 30%",
  "Reliable Service",
  "Great Prices",
];

export const SERVICES = [
  {
    id: "business",
    tab: "Business Waste Pickup",
    title: "Business Waste Pickup",
    capacity: "1 – 8 Yard Dumpsters",
    badge: "Commercial · Scheduled",
    description:
      "If your business in Miami needs waste service, we provide 1-8 yard dumpsters to accommodate any business waste stream. Our experienced team has over 25 years of expertise to ensure great pricing, awesome service, and superior customer support. Contact us today to start managing your waste efficiently and cost-effectively.",
    image:
      "/img/front-load-dumpster-truck-miami.jpg",
    points: ["Restaurants & Retail", "Offices & Warehouses", "Multi-Family Properties"],
  },
  {
    id: "rolloff",
    tab: "Roll-Off Dumpster Rental",
    title: "Roll-Off Dumpster Rental",
    capacity: "10 – 40 Yard Containers",
    badge: "Construction · Heavy Duty",
    description:
      "EWS is your go-to company for all your waste management needs. Whether you are a business or a residence, we have the resources and the expertise to provide you with the best waste management services. We provide efficient and affordable roll-off dumpsters that range from 10 to 40 yards.",
    image:
      "/img/rolloff-truck.webp",
    points: ["Construction Debris", "Renovations & Roofing", "Industrial Cleanouts"],
  },
];

export const WASTE_TYPES = [
  "Universal Waste",
  "Food Waste",
  "Hazardous Materials",
  "Construction & Demolition Debris",
  "Plastics, Metal and Textile",
  "Cardboard",
  "Pallets",
  "Paper",
  "Grease & Oil",
  "Electronic Waste",
];

export const PILLARS = [
  {
    num: "01",
    title: "Our Service Guarantee",
    desc: "We stand behind every pickup. If we ever fall short of our service agreement and don't make it right within 5 business days of written notice, you can cancel without penalty — that's our written promise to you.",
  },
  {
    num: "02",
    title: "High-Touch Customer Service",
    desc: "Real people who pick up the phone. Our Miami-based team is trained to give new and existing customers fast, knowledgeable and genuinely helpful support — every single call.",
  },
  {
    num: "03",
    title: "Utmost Service Reliability",
    desc: "Dependable, on-time pickups you can count on. We keep your containers swapped on schedule and your site clean, week after week, with no missed collections.",
  },
  {
    num: "04",
    title: "30+ Years & Price-Beat",
    desc: "Three decades hauling waste across Miami-Dade — and we'll beat or match your current hauler's price. Proven local experience paired with real savings.",
  },
];

export const REVIEWS = [
  {
    title: "Reliable Service",
    body: "When choosing our service you can rely on professional and sustainable service all the time.",
    author: "Verified Customer",
    city: "Miami, FL",
  },
  {
    title: "Good Customer Service",
    body: "When dealing with our service agents you can be assured you're dealing with professional and knowledgeable waste service professionals.",
    author: "Verified Customer",
    city: "Hialeah, FL",
  },
  {
    title: "Great Prices",
    body: "We've been in the business for more than 30 years, we know how to sort your trash to pass our customers the savings.",
    author: "Verified Customer",
    city: "Doral, FL",
  },
  {
    title: "On-Time, Every Time",
    body: "Our containers are always swapped out on schedule and the dispatch team is easy to reach whenever we need an extra pickup.",
    author: "Local Restaurant Owner",
    city: "Kendall, FL",
  },
  {
    title: "Switched & Saved",
    body: "We switched from our old hauler and immediately cut our monthly waste bill. Wish we had done it sooner.",
    author: "Property Manager",
    city: "Coral Gables, FL",
  },
  {
    title: "Truly Sustainable",
    body: "EWS helped us set up a recycling plan that actually works for our building. Great for our tenants and the environment.",
    author: "Condo Association",
    city: "Aventura, FL",
  },
];

export const CITIES = [
  "Miami", "North Miami", "Aventura", "Bal Harbour", "Sunny Isles",
  "Opa Locka", "Hialeah", "North Bay Village", "Surfside", "Golden Shores",
  "Golden Beach", "Miami Gardens", "Carol City", "Miami Lakes", "North Miami Beach",
  "Doral", "Miami Shores", "Biscayne Gardens", "Medley", "Miami Springs",
  "Sweetwater", "Biscayne Park", "Miami Beach", "Coral Gables", "Homestead",
  "Florida City", "Cutler Bay", "Palmetto Bay", "Pinecrest", "South Miami",
  "West Miami", "Key Biscayne", "Hialeah Gardens", "Bay Harbor Islands",
  "Indian Creek", "El Portal", "Virginia Gardens", "Kendall",
];

export const CITY_COORDS = [
  { name: "Miami", lat: 25.7617, lng: -80.1918 },
  { name: "North Miami", lat: 25.8901, lng: -80.1867 },
  { name: "Aventura", lat: 25.9565, lng: -80.1429 },
  { name: "Bal Harbour", lat: 25.8916, lng: -80.1264 },
  { name: "Sunny Isles", lat: 25.9290, lng: -80.1226 },
  { name: "Opa Locka", lat: 25.9020, lng: -80.2503 },
  { name: "Hialeah", lat: 25.8576, lng: -80.2781 },
  { name: "North Bay Village", lat: 25.8465, lng: -80.1537 },
  { name: "Surfside", lat: 25.8787, lng: -80.1256 },
  { name: "Golden Shores", lat: 25.9270, lng: -80.1350 },
  { name: "Golden Beach", lat: 25.9662, lng: -80.1226 },
  { name: "Miami Gardens", lat: 25.9420, lng: -80.2456 },
  { name: "Carol City", lat: 25.9440, lng: -80.2600 },
  { name: "Miami Lakes", lat: 25.9087, lng: -80.3087 },
  { name: "North Miami Beach", lat: 25.9331, lng: -80.1625 },
  { name: "Doral", lat: 25.8195, lng: -80.3553 },
  { name: "Miami Shores", lat: 25.8637, lng: -80.1931 },
  { name: "Biscayne Gardens", lat: 25.8890, lng: -80.1990 },
  { name: "Medley", lat: 25.8390, lng: -80.3320 },
  { name: "Miami Springs", lat: 25.8220, lng: -80.2895 },
  { name: "Sweetwater", lat: 25.7637, lng: -80.3731 },
  { name: "Biscayne Park", lat: 25.8826, lng: -80.1793 },
  { name: "Miami Beach", lat: 25.7907, lng: -80.1300 },
  { name: "Coral Gables", lat: 25.7215, lng: -80.2684 },
  { name: "Homestead", lat: 25.4687, lng: -80.4776 },
  { name: "Florida City", lat: 25.4479, lng: -80.4792 },
  { name: "Cutler Bay", lat: 25.5808, lng: -80.3467 },
  { name: "Palmetto Bay", lat: 25.6220, lng: -80.3247 },
  { name: "Pinecrest", lat: 25.6673, lng: -80.3084 },
  { name: "South Miami", lat: 25.7079, lng: -80.2939 },
  { name: "West Miami", lat: 25.7601, lng: -80.2967 },
  { name: "Key Biscayne", lat: 25.6937, lng: -80.1626 },
  { name: "Hialeah Gardens", lat: 25.8629, lng: -80.3247 },
  { name: "Bay Harbor Islands", lat: 25.8882, lng: -80.1300 },
  { name: "Indian Creek", lat: 25.8790, lng: -80.1400 },
  { name: "El Portal", lat: 25.8562, lng: -80.1931 },
  { name: "Virginia Gardens", lat: 25.8090, lng: -80.3020 },
  { name: "Kendall", lat: 25.6793, lng: -80.3173 },
];

// ---- Business Waste Service page ----
export const BUSINESS_INTRO =
  "At EWS, we understand that sustainability is not only good for the environment, but it's also good for business. That's why we are dedicated to providing dependable and cost-effective commercial waste management services. Our team offers a variety of bin sizes, pickup schedules and recycling options to help make every business more efficient. We are committed to helping you reduce, reuse and recycle in order to create a more sustainable future.";

export const BUSINESS_DUMPSTERS_INTRO =
  "EWS offers comprehensive waste management services to businesses in Miami. We provide 1 to 8 yard dumpsters for a variety of needs at affordable prices and with efficient service. Maximize your business operations with our quality waste management solutions.";

export const BUSINESS_FEATURES = [
  { title: "Reliable Container Delivery", desc: "Delivered and swapped on your schedule." },
  { title: "One-Year Service Agreement", desc: "Gives you choice and flexibility." },
  { title: "Price Transparency", desc: "Means no surprise fees." },
];

export const SERVICE_GUARANTEE =
  "If we fail to provide Service as per our Agreement and don't fix the problem within 5 business days after written notice, you can terminate our commercial trash services without penalty.";

export const DUMPSTER_SIZES = [
  {
    size: "2 Yard Dumpster",
    desc: "The 2 yard dumpster is good for small restaurants, medical clinics, and companies with limited space.",
    bags: "Holds around 14 bags (32 gallons each).",
    dims: "3' H × 3' D × 6' W",
    img: "/img/2-yard-front-load-dumpster.jpg",
  },
  {
    size: "3 Yard Dumpster",
    desc: "The 3 yard dumpster size is ideal for small businesses and companies with limited outdoor space.",
    bags: "Holds around 21 bags (32 gallons each).",
    dims: "4' H × 3'5\" D × 6' W",
    img: "/img/3-yard-front-load-dumpster.jpg",
  },
  {
    size: "4 Yard Dumpster",
    desc: "Offices with up to 50 employees should consider the 4 yard dumpster for their commercial waste needs.",
    bags: "Holds around 28 bags (32 gallons each).",
    dims: "4' H × 4'6\" D × 6' W",
    img: "/img/4-yard-front-load-dumpster.jpg",
  },
  {
    size: "6 Yard Dumpster",
    desc: "The 6 yard dumpster is for medium to large retail stores, clinics, restaurants and offices with up to 100 employees will likely need the 6-yard.",
    bags: "Holds around 42 bags (32 gallons each).",
    dims: "6' H × 4'6\" D × 6' W",
    img: "/img/6-yard-front-load-dumpster.jpg",
  },
  {
    size: "8 Yard Dumpster",
    desc: "Our 8 yard dumpster is our largest front load size, the 8-yard, is a perfect fit for large businesses like high volume restaurants and offices with up to 250 employees.",
    bags: "Holds around 56 bags (32 gallons each).",
    dims: "6' H × 6' D × 6' W",
    img: "/img/8-yard-front-load-dumpster.jpg",
  },
];

export const PROCESS_STEPS = [
  {
    step: "01",
    title: "Receive an Instant Quote Over the Phone",
    desc: "Call 305-691-1516 to speak with one of our specialists and get a free instant quote over the phone. Our specialists will help you find the perfect size for your business.",
  },
  {
    step: "02",
    title: "Start Service",
    desc: "You'll get an email with the documents that need to be completed and with the details for your commercial waste service collections.",
  },
  {
    step: "03",
    title: "Start Using Our Service",
    desc: "Schedule extra pickups, change service levels and more, all in one convenient place.",
  },
];

export const BUSINESS_ANY_INTRO =
  "We proudly serve the Miami-Dade County area with premier commercial waste collection with affordable prices. Whether you are an office or condominium, our sustainable garbage collection service is perfect for all types businesses. Your business trash is unique and your needs are complex. And what works for other businesses may not work for yours. That's why Empire Waste is passionately dedicated about helping you create a customized waste and recycling plan that's specific to your needs, environmental goals and budget.";

export const BUSINESS_TYPES = [
  "Industrial",
  "Condominiums",
  "Hospitals and Clinics",
  "Offices",
  "Food Service Restaurants",
  "Retail Stores",
  "Shopping Centers",
  "Hotels",
];

// ---- Per-size SEO detail pages (front-load commercial dumpsters) ----
const DUMP_IMG = "/img/";

export const DUMPSTER_DETAILS = [
  {
    slug: "2-yard-dumpster",
    yard: "2",
    title: "2 Yard Dumpster",
    watermark: "2 YARD",
    holds: "10 – 24 bags of trash",
    dimensions: "6' L × 3' W × 3' H",
    includes: "Reliable delivery and pickup, flexible pickup schedules, and a designated account manager.",
    intro:
      "The 2 yard dumpster is our smallest front-load commercial container — perfect for small businesses with limited space and lower waste volumes. Its compact footprint fits tight enclosures, back alleys and shared bin corrals while still keeping your trash contained and out of sight.",
    idealFor: [
      "Small offices with under 25 employees",
      "Boutiques and small retail shops",
      "Coffee shops and cafés",
      "Salons, studios and small clinics",
      "Businesses with limited outdoor space",
    ],
    whatsIncluded: [
      "Reliable container delivery and pickup",
      "Flexible, scheduled collections",
      "Transparent, all-in pricing",
      "A dedicated EWS account manager",
    ],
    img: DUMP_IMG + "2-yard-front-load-dumpster.jpg",
    priceFrom: "$55",
    seoTitle: "2 Yard Dumpster Rental in Miami | EWS Commercial Waste",
    seoDesc: "Affordable 2 yard commercial dumpster rental in Miami from $55/mo. Reliable delivery & pickup, flexible scheduling. Perfect for small offices, cafés & shops.",
    faqs: [
      { q: "How much does a 2 yard dumpster cost in Miami?", a: "EWS 2 yard commercial dumpster service starts at $55/month with reliable pickups and flexible scheduling. Your final rate depends on pickup frequency and location." },
      { q: "What businesses is a 2 yard dumpster best for?", a: "It's ideal for small offices under 25 employees, boutiques, coffee shops, salons and small clinics with lower waste volumes." },
      { q: "How much space does a 2 yard dumpster need?", a: "The container measures 6' L × 3' W × 3' H, so it fits tight enclosures, back alleys and shared bin corrals with room for the truck to service it." },
    ],
  },
  {
    slug: "3-yard-dumpster",
    yard: "3",
    title: "3 Yard Dumpster",
    watermark: "3 YARD",
    holds: "10 – 30 bags of trash",
    dimensions: "4' L × 3'5\" W × 6' H",
    includes: "Reliable delivery and pickup, convenient scheduling, and a designated account manager.",
    intro:
      "The 3 yard dumpster is a popular intermediate size that steps up capacity without taking much more ground space. It's a great fit for light-retail and service businesses that have outgrown a 2-yard but don't yet need a full mid-size container.",
    idealFor: [
      "Light retail and service businesses",
      "Salons, spas and studios",
      "Offices with up to 50 employees",
      "Small medical and dental clinics",
      "Businesses with limited outdoor space",
    ],
    whatsIncluded: [
      "Reliable container delivery and pickup",
      "Convenient scheduling and account management",
      "Transparent, all-in pricing",
      "A dedicated EWS account manager",
    ],
    img: DUMP_IMG + "3-yard-front-load-dumpster.jpg",
    priceFrom: "$80",
    seoTitle: "3 Yard Dumpster Rental in Miami | EWS Commercial Waste",
    seoDesc: "3 yard commercial dumpster rental in Miami from $80/mo. Reliable delivery & pickup. Ideal for light retail, salons & offices with up to 50 employees.",
    faqs: [
      { q: "How much does a 3 yard dumpster cost in Miami?", a: "EWS 3 yard service starts at $80/month with reliable pickups and convenient scheduling. Pricing varies with how often the container is emptied." },
      { q: "What businesses is a 3 yard dumpster best for?", a: "Light retail and service businesses, salons, spas and offices with up to 50 employees that have outgrown a 2-yard container." },
      { q: "What are the 3 yard dumpster dimensions?", a: "It measures roughly 4' L × 3'5\" W × 6' H and holds about 10–30 bags of trash." },
    ],
  },
  {
    slug: "4-yard-dumpster",
    yard: "4",
    title: "4 Yard Dumpster",
    watermark: "4 YARD",
    holds: "18 – 48 bags of trash",
    dimensions: "6' L × 4'6\" W × 4' H",
    includes: "Reliable delivery and pickup, convenient scheduling, and a designated account manager.",
    intro:
      "The 4 yard dumpster is the mid-sized workhorse of commercial waste — the most popular choice for businesses that generate a steady, moderate stream of trash. It balances capacity and footprint, making it easy to place while keeping pickups efficient.",
    idealFor: [
      "Mid-sized restaurants and cafés",
      "Convenience and retail stores",
      "Offices with up to 100 employees",
      "Medical clinics and small facilities",
      "Multi-tenant and mixed-use buildings",
    ],
    whatsIncluded: [
      "Reliable container delivery and pickup",
      "Convenient scheduling and account management",
      "Transparent, all-in pricing",
      "A dedicated EWS account manager",
    ],
    img: DUMP_IMG + "4-yard-front-load-dumpster.jpg",
    priceFrom: "$105",
    seoTitle: "4 Yard Dumpster Rental in Miami | EWS Commercial Waste",
    seoDesc: "4 yard commercial dumpster rental in Miami from $105/mo — the mid-size workhorse for restaurants, retail & offices up to 100 employees. Reliable service.",
    faqs: [
      { q: "How much does a 4 yard dumpster cost in Miami?", a: "EWS 4 yard commercial service starts at $105/month, with reliable pickups and dedicated account management." },
      { q: "What businesses is a 4 yard dumpster best for?", a: "The mid-sized workhorse — great for mid-sized restaurants, convenience and retail stores, and offices with up to 100 employees." },
      { q: "How much trash does a 4 yard dumpster hold?", a: "About 18–48 bags of trash. It measures roughly 6' L × 4'6\" W × 4' H." },
    ],
  },
  {
    slug: "6-yard-dumpster",
    yard: "6",
    title: "6 Yard Dumpster",
    watermark: "6 YARD",
    holds: "36 – 72 bags of trash",
    dimensions: "6' L × 4'6\" W × 6' H",
    includes: "Reliable delivery and pickup, convenient scheduling, and a designated account manager.",
    intro:
      "The 6 yard dumpster is built for higher-volume operations that need serious capacity without moving up to the largest container. It's a frequent choice for busy restaurants, larger offices and retail centers that fill bins quickly between pickups.",
    idealFor: [
      "Busy and high-volume restaurants",
      "Large office buildings",
      "Strip malls and retail centers",
      "Medium-to-large businesses (up to 250 employees)",
      "Apartment and condominium communities",
    ],
    whatsIncluded: [
      "Reliable container delivery and pickup",
      "Convenient scheduling and account management",
      "Transparent, all-in pricing",
      "A dedicated EWS account manager",
    ],
    img: DUMP_IMG + "6-yard-front-load-dumpster.jpg",
    priceFrom: "$130",
    seoTitle: "6 Yard Dumpster Rental in Miami | EWS Commercial Waste",
    seoDesc: "6 yard commercial dumpster rental in Miami from $130/mo for busy restaurants, offices & strip malls up to 250 employees. Reliable delivery & pickup.",
    faqs: [
      { q: "How much does a 6 yard dumpster cost in Miami?", a: "EWS 6 yard service starts at $130/month with reliable pickups and a dedicated account manager." },
      { q: "What businesses is a 6 yard dumpster best for?", a: "Busy restaurants, large office buildings, strip malls and medium-to-large businesses with up to 250 employees." },
      { q: "How much trash does a 6 yard dumpster hold?", a: "About 36–72 bags of trash. It measures roughly 6' L × 4'6\" W × 6' H." },
    ],
  },
  {
    slug: "8-yard-dumpster",
    yard: "8",
    title: "8 Yard Dumpster",
    watermark: "8 YARD",
    holds: "48 – 96 bags of trash",
    dimensions: "6' L × 6' W × 6' H",
    includes: "Reliable delivery and pickup, convenient scheduling, and a designated account manager.",
    intro:
      "The 8 yard dumpster is our largest standard front-load size — engineered for high-volume waste producers. If your business fills smaller containers before every scheduled pickup, the 8-yard keeps everything contained and your operation running smoothly.",
    idealFor: [
      "High-volume restaurants and food service",
      "Large hotels and grocery stores",
      "Manufacturing and industrial facilities",
      "Universities and large campuses",
      "Large offices (up to 500 employees)",
    ],
    whatsIncluded: [
      "Reliable container delivery and pickup",
      "Convenient scheduling and account management",
      "Transparent, all-in pricing",
      "A dedicated EWS account manager",
    ],
    img: DUMP_IMG + "8-yard-front-load-dumpster.jpg",
    priceFrom: "$174",
    seoTitle: "8 Yard Dumpster Rental in Miami | EWS Commercial Waste",
    seoDesc: "8 yard commercial dumpster rental in Miami from $174/mo — our largest front-load size for high-volume businesses up to 500 employees. Reliable service.",
    faqs: [
      { q: "How much does an 8 yard dumpster cost in Miami?", a: "EWS 8 yard commercial service starts at $174/month, with reliable pickups and convenient scheduling." },
      { q: "What businesses is an 8 yard dumpster best for?", a: "Our largest front-load size — built for high-volume restaurants, hotels, grocery stores, manufacturing facilities and large offices up to 500 employees." },
      { q: "How much trash does an 8 yard dumpster hold?", a: "About 48–96 bags of trash. It measures roughly 6' L × 6' W × 6' H." },
    ],
  },
];

// ---- Roll-off dumpster rentals page ----
const RO_IMG = "/img/";
const RO_10 = RO_IMG + "10-yard-roll-off-dumpster.jpg";
const RO_20 = RO_IMG + "20-yard-roll-off-dumpster.jpg";
const RO_30 = RO_IMG + "30-yard-roll-off-dumpster.jpg";
const RO_40 = RO_IMG + "40-yard-roll-off-dumpster.jpg";

export const ROLLOFF_SIZES = [
  { size: "10 Yard", slug: "10-yard-roll-off-dumpster", desc: "Ideal for small cleanouts, single-room renovations and small landscaping jobs.", dims: "14' L × 7'6\" W × 3'6\" H", img: RO_10 },
  { size: "20 Yard", slug: "20-yard-roll-off-dumpster", desc: "Great for medium remodels, flooring or roofing tear-offs and larger cleanouts.", dims: "22' L × 7'6\" W × 4'6\" H", img: RO_20 },
  { size: "30 Yard", slug: "30-yard-roll-off-dumpster", desc: "Built for major renovations, new construction and large commercial cleanups.", dims: "22' L × 7'6\" W × 6' H", img: RO_30 },
  { size: "40 Yard", slug: "40-yard-roll-off-dumpster", desc: "Our largest container for the biggest construction and demolition projects.", dims: "22' L × 7'6\" W × 8' H", img: RO_40 },
];

export const ROLLOFF_DETAILS = [
  {
    slug: "10-yard-roll-off-dumpster", yard: "10", title: "10 Yard Roll-Off Dumpster", watermark: "10 YARD",
    holds: "≈ 3 pickup-truck loads of debris", dimensions: "14' L × 7'6\" W × 3'6\" H", weightLimit: "1 – 2 tons included",
    includes: "Reliable delivery, pickup and a set rental period with transparent, all-in pricing.",
    intro: "The 10 yard roll-off is our most compact open-top container — perfect for small, heavy jobs and tight driveways. Its low profile makes loading easy and keeps it out of the way on smaller Miami properties.",
    idealFor: ["Small home & garage cleanouts", "Single-room renovations", "Small roofing tear-offs", "Concrete, dirt & heavy debris", "Yard & landscaping waste"],
    whatsIncluded: ["Reliable delivery and pickup", "Set rental period", "Transparent, all-in pricing", "A dedicated EWS account manager"],
    priceFrom: "$289", priceUnit: "/14-day", priceNote: "for a 14-day rental", img: RO_10,
    seoTitle: "10 Yard Roll-Off Dumpster Rental in Miami | EWS",
    seoDesc: "10 yard roll-off dumpster rental in Miami from $289. Reliable delivery & pickup. Ideal for small cleanouts, single-room remodels, concrete & heavy debris.",
    faqs: [
      { q: "How much does a 10 yard dumpster rental cost in Miami?", a: "EWS 10 yard roll-off rentals start at $289 and include a 14-day rental period, delivery and pickup. Final pricing depends on debris type and rental length." },
      { q: "What are the dimensions of a 10 yard dumpster?", a: "About 14' long × 7'6\" wide × 3'6\" high — a low profile that fits most driveways and holds roughly 3 pickup-truck loads." },
      { q: "What can I put in a 10 yard roll-off?", a: "It's great for small cleanouts, single-room remodels, roofing tear-offs and heavy materials like concrete, brick and dirt." },
    ],
  },
  {
    slug: "20-yard-roll-off-dumpster", yard: "20", title: "20 Yard Roll-Off Dumpster", watermark: "20 YARD",
    holds: "≈ 6 pickup-truck loads of debris", dimensions: "22' L × 7'6\" W × 4'6\" H", weightLimit: "2 – 3 tons included",
    includes: "Reliable delivery, pickup and a set rental period with transparent, all-in pricing.",
    intro: "The 20 yard roll-off is the most popular all-purpose container — the sweet spot between capacity and footprint. It handles the majority of home remodels and mid-sized commercial cleanups with ease.",
    idealFor: ["Medium home remodels", "Flooring & carpet removal", "Roofing tear-offs (up to ~3,000 sq ft)", "Large garage & estate cleanouts", "Deck or fence removal"],
    whatsIncluded: ["Reliable delivery and pickup", "Set rental period", "Transparent, all-in pricing", "A dedicated EWS account manager"],
    priceFrom: "$289", priceUnit: "/14-day", priceNote: "for a 14-day rental", img: RO_20,
    seoTitle: "20 Yard Roll-Off Dumpster Rental in Miami | EWS",
    seoDesc: "20 yard roll-off dumpster rental in Miami from $289. Reliable delivery & pickup. The all-purpose size for remodels, roofing, flooring and big cleanouts.",
    faqs: [
      { q: "How much does a 20 yard dumpster rental cost in Miami?", a: "EWS 20 yard roll-off rentals start at $289 with a 14-day rental period, reliable delivery and pickup." },
      { q: "What are the dimensions of a 20 yard dumpster?", a: "About 22' long × 7'6\" wide × 4'6\" high, holding roughly 6 pickup-truck loads of debris." },
      { q: "What is a 20 yard dumpster best for?", a: "It's our most popular size — ideal for medium remodels, roofing, flooring removal and large household or estate cleanouts." },
    ],
  },
  {
    slug: "30-yard-roll-off-dumpster", yard: "30", title: "30 Yard Roll-Off Dumpster", watermark: "30 YARD",
    holds: "≈ 9 pickup-truck loads of debris", dimensions: "22' L × 7'6\" W × 6' H", weightLimit: "3 – 4 tons included",
    includes: "Reliable delivery, pickup and a set rental period with transparent, all-in pricing.",
    intro: "The 30 yard roll-off is built for major projects that generate large volumes of bulky, lightweight debris. Its taller walls make it a favorite for construction, demolition and big commercial cleanups.",
    idealFor: ["Major home additions & renovations", "New construction debris", "Commercial construction cleanups", "Whole-home & estate cleanouts", "Bulky, lightweight demolition debris"],
    whatsIncluded: ["Reliable delivery and pickup", "Set rental period", "Transparent, all-in pricing", "A dedicated EWS account manager"],
    priceFrom: "$289", priceUnit: "/14-day", priceNote: "for a 14-day rental", img: RO_30,
    seoTitle: "30 Yard Roll-Off Dumpster Rental in Miami | EWS",
    seoDesc: "30 yard roll-off dumpster rental in Miami from $289. Reliable delivery & pickup. Built for major renovations, new construction and large demolition debris.",
    faqs: [
      { q: "How much does a 30 yard dumpster rental cost in Miami?", a: "EWS 30 yard roll-off rentals start at $289 and include a 14-day rental period, delivery and pickup." },
      { q: "What are the dimensions of a 30 yard dumpster?", a: "About 22' long × 7'6\" wide × 6' high, holding roughly 9 pickup-truck loads of debris." },
      { q: "What is a 30 yard dumpster best for?", a: "Major renovations, new construction, commercial cleanups and large volumes of bulky, lightweight debris." },
    ],
  },
  {
    slug: "40-yard-roll-off-dumpster", yard: "40", title: "40 Yard Roll-Off Dumpster", watermark: "40 YARD",
    holds: "≈ 12 pickup-truck loads of debris", dimensions: "22' L × 7'6\" W × 8' H", weightLimit: "4 – 6 tons included",
    includes: "Reliable delivery, pickup and a set rental period with transparent, all-in pricing.",
    intro: "The 40 yard roll-off is our largest container — engineered for the biggest construction, demolition and commercial jobs. When a project produces massive amounts of debris, the 40-yard keeps the site clear and productive.",
    idealFor: ["Large-scale construction & demolition", "Commercial & industrial cleanouts", "Major roofing & siding jobs", "Warehouse & retail build-outs", "High-volume, bulky debris"],
    whatsIncluded: ["Reliable delivery and pickup", "Set rental period", "Transparent, all-in pricing", "A dedicated EWS account manager"],
    priceFrom: "$289", priceUnit: "/14-day", priceNote: "for a 14-day rental", img: RO_40,
    seoTitle: "40 Yard Roll-Off Dumpster Rental in Miami | EWS",
    seoDesc: "40 yard roll-off dumpster rental in Miami from $289. Reliable delivery & pickup. Our largest container for major construction, demolition and commercial jobs.",
    faqs: [
      { q: "How much does a 40 yard dumpster rental cost in Miami?", a: "EWS 40 yard roll-off rentals start at $289 with a 14-day rental period, reliable delivery and pickup." },
      { q: "What are the dimensions of a 40 yard dumpster?", a: "About 22' long × 7'6\" wide × 8' high — our largest size, holding roughly 12 pickup-truck loads of debris." },
      { q: "What is a 40 yard dumpster best for?", a: "Large-scale construction and demolition, commercial cleanouts and any job producing high volumes of bulky debris." },
    ],
  },
];

// ---- 301 Redirect map: legacy (Wix) URLs -> new site paths ----
// Preserves existing search rankings when the new site launches on eewaste.com.
export const REDIRECTS = [
  { from: "/affordablewastecollection", to: "/business-waste-service" },
  { from: "/garbageservicecustomers", to: "/business-waste-service" },
  { from: "/miami-fl-dumpster-rental-florida", to: "/dumpster-rentals" },
  { from: "/10yard-roll-off-dumpsterrentals", to: "/dumpster-rentals/10-yard-roll-off-dumpster" },
  { from: "/20-yard-roll-offdumpsterrentals", to: "/dumpster-rentals/20-yard-roll-off-dumpster" },
  { from: "/30-yard-roll-off-dumpsterrentals", to: "/dumpster-rentals/30-yard-roll-off-dumpster" },
  { from: "/40-yard-roll-off-dumspterrentals", to: "/dumpster-rentals/40-yard-roll-off-dumpster" },
  { from: "/waste-service-quick-quote", to: "/quick-quote" },
];

// ---- Roll-Off Dumpster Rentals hub: SEO content ----
export const ROLLOFF_COST_POINTS = [
  { label: "Flat, all-in rate", value: "From $289", note: "14-day rental period included" },
  { label: "Delivery & pickup", value: "On schedule", note: "Delivered and collected across Miami-Dade" },
  { label: "Weight allowance", value: "Included", note: "Generous tonnage built into every rental" },
  { label: "Same-day delivery", value: "Available", note: "Call early — subject to truck availability" },
];

export const DUMPSTER_RENTAL_FAQS = [
  {
    q: "How much does a dumpster rental cost in Miami?",
    a: "EWS roll-off dumpster rentals start at $289 and include a 14-day rental period, reliable delivery and pickup and a generous weight allowance. We use simple flat-rate pricing with no surprise fees — your final cost depends only on the size you choose, the type of debris and how long you keep the container. Call (305) 691-1516 for an exact quote in minutes.",
  },
  {
    q: "What size dumpster do I need for my project?",
    a: "As a rule of thumb: a 10-yard suits small cleanouts, single-room remodels and heavy debris like concrete; a 20-yard is the most popular all-purpose size for medium remodels, flooring and roofing tear-offs; a 30-yard handles major renovations and new construction; and a 40-yard is for large-scale construction, demolition and commercial jobs. Not sure? Our team will recommend the right size over the phone so you don't overpay for space you won't use.",
  },
  {
    q: "What can't go in a roll-off dumpster?",
    a: "For safety and Florida disposal rules, we can't accept hazardous materials such as paint, solvents, motor oil, chemicals, tires, wet paint, asbestos, batteries, propane tanks, medical waste or appliances containing Freon (like refrigerators and A/C units). Everyday construction debris, household junk, furniture, wood, drywall, roofing and yard waste are all fine. When in doubt, just ask us before you load it.",
  },
  {
    q: "How long can I keep a rental dumpster?",
    a: "Every EWS roll-off rental includes a standard 14-day rental period. Need it longer? Just let us know — we offer flexible extensions at affordable daily rates, and we can schedule an early swap-out or pickup whenever your project wraps up.",
  },
  {
    q: "Do I need a permit for a dumpster in Miami-Dade?",
    a: "If the dumpster sits on your own private property — like a driveway — you typically don't need a permit. If it has to be placed on a public street, sidewalk or right-of-way, most Miami-Dade municipalities require a right-of-way permit. We deliver across Miami-Dade every day and can walk you through the local permit requirements for your city so placement is fully compliant.",
  },
  {
    q: "Do you offer same-day dumpster delivery in Miami?",
    a: "Yes — same-day and next-day roll-off delivery is often available across Miami and Miami-Dade County. Availability depends on the time of day and our truck schedule, so the earlier you call, the better your odds. Reach us at (305) 691-1516 to check same-day options.",
  },
  {
    q: "Can I put concrete, dirt or other heavy debris in a roll-off?",
    a: "Yes — roll-off dumpsters are built for heavy material like concrete, brick, dirt, tile and asphalt. For dense debris we'll often recommend a 10 or 20 yard container so you stay within the included weight allowance, and we'll help you pick the right size when you call. Just keep heavy debris separate from prohibited items like hazardous waste.",
  },
];

// ---- Commercial Weekly Waste Service (Business Waste) ----
export const WEEKLY_INTRO =
  "Most Miami businesses don't need a one-off dumpster — they need dependable, scheduled pickups that keep their site clean week after week. EWS builds a recurring commercial waste plan around your volume and hours: pick a front-load container size, choose how many times per week you want it emptied, and we handle the rest. From a single weekly pickup for a small office to daily service for a high-volume restaurant, our routes cover all of Miami-Dade County.";

export const WEEKLY_FREQUENCIES = [
  { freq: "1× / week", for: "Small offices, salons & boutiques" },
  { freq: "2× / week", for: "Cafés, clinics & mid-size retail" },
  { freq: "3× / week", for: "Busy restaurants & strip malls" },
  { freq: "4–5× / week", for: "High-volume food service & hotels" },
  { freq: "6–7× / week", for: "Grocery, industrial & large campuses" },
];

export const BUSINESS_WASTE_FAQS = [
  {
    q: "How much does commercial waste service cost in Miami?",
    a: "EWS commercial front-load waste service starts at $55/month and is priced on two simple factors: the container size (2–8 yard) and how often it's emptied each week. Because we've hauled Miami waste for 30+ years, we can usually beat your current hauler's rate — most businesses save up to 30% when they switch. Call (305) 691-1516 for a free, no-obligation price comparison.",
  },
  {
    q: "How often can my business get waste pickup?",
    a: "As often as you need. We offer flexible weekly schedules from a single pickup per week up to daily (7× per week) service. If your volume changes seasonally, we'll adjust your schedule — you're never locked into paying for pickups you don't use.",
  },
  {
    q: "Can EWS help my business recycle?",
    a: "Absolutely. We set up commercial recycling programs for cardboard, paper, plastics, metal, glass and more, and we can pair recycling with your regular trash pickup. It's better for the environment and can lower your overall disposal costs by diverting material from the landfill.",
  },
  {
    q: "Can I switch from my current waste hauler?",
    a: "Yes, and it's easier than most business owners expect. Send us a recent invoice (or snap a photo with our WiseWaste™ tool) and we'll show you exactly what you'd save. Our team handles the container swap and scheduling so there's no gap in service — most switches are seamless.",
  },
  {
    q: "What size front-load dumpster does my business need?",
    a: "A 2-yard suits small offices and shops; a 3–4 yard fits mid-size retail, cafés and offices up to 100 employees; a 6-yard handles busy restaurants and larger buildings; and an 8-yard is our largest size for high-volume restaurants, hotels and facilities. We'll right-size it on a quick call so you're not paying for empty space.",
  },
  {
    q: "Do you provide commercial waste service across all of Miami-Dade?",
    a: "Yes — we serve businesses throughout Miami-Dade County, including Miami, Hialeah, Doral, Kendall, Homestead, Coral Gables, Miami Beach, Aventura, Miami Lakes and 30+ other communities. Wherever your business is in the county, we can service it.",
  },
  {
    q: "What types of businesses does EWS serve in Miami?",
    a: "We manage waste for restaurants and food service, retail stores and shopping centers, offices, medical and dental clinics, hotels, warehouses and industrial sites, and multi-family and condominium communities across Miami-Dade. Whatever your industry, we'll tailor container size and pickup frequency to match your exact volume.",
  },
];

// ---- Who We Are ----
export const ABOUT_STORY =
  "For over 30 years, Empire Environmental Waste (EWS) has provided affordable, reliable waste management and dumpster rental services across Miami and Miami-Dade County. We're a local team dedicated to sustainable service — helping businesses and residents reduce, reuse and recycle while saving money. From single dumpster pickups to full commercial waste programs, we build customized plans around your needs, your budget and your environmental goals. As a locally owned and operated company, we know Miami-Dade's neighborhoods, routes and permitting inside out — and we back every account with a written service guarantee, responsive local support and the on-time reliability our customers count on week after week.";

export const IMAGES = {
  logoBadge: "/img/ews-logo.jpg",
  recycling: "/img/miami-recycling.jpg",
  miami: "/img/miami-skyline.jpg",
  frontloadDumpster: "/img/frontload-dumpster.webp",
  rolloffDumpster: "/img/20-yard-roll-off-dumpster.jpg",
  rolloffTruck: "/img/rolloff-truck.webp",
};
